import React, { useEffect, useState } from "react";
import { convertTime } from "../../utils/Helper";
import { MEDIA_BASE_URL } from "../../constants";
import ImageViewModal from "../UserProfile/ImageViewModal";
import { useNavigate } from "react-router";
import { translateText } from "../../utils/Translate";
import { FormattedMessage } from "react-intl";

export const SenderMessageBox = ({ item }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [transactionLoading, setTranslationLoading] = useState(false);
  const [translatedText, setTranslatedText] = useState(
    item?.message ? item?.message : ""
  );

  const navigate = useNavigate();
  const openModal = (url) => {
    setImageUrl({ key: url });
    setModalOpen(true);
  };
  useEffect(() => {
    (async () => {
      setTranslationLoading(true);
      const text = await translateText(translatedText);
      setTranslationLoading(false);
      setTranslatedText(text);
    })();
  }, []);

  const extractContractId = item?.message?.match(/\d+/);
  let contractId;
  if (extractContractId) {
    contractId = extractContractId[0];
  }
  return (
    <div>
      {modalOpen && (
        <ImageViewModal
          showModal={modalOpen}
          setShowModal={setModalOpen}
          images={[ImageUrl]}
          index={0}
        />
      )}
      <div className="chat-message sender">
        {item?.type === "text" ? (
          <>
            <span className="long-text">
              {transactionLoading ? (
                <FormattedMessage id="Translating..." />
              ) : (
                translatedText
              )}
            </span>
          </>
        ) : item?.type === "image/jpeg" ? (
          <div onClick={() => openModal(item?.message_file_key)}>
            <img
              src={`${MEDIA_BASE_URL}${item?.message_file_key}`}
              className="w-100 h-100"
            />
          </div>
        ) : ["audio/aac", "audio/m4a", "audio/x-m4a"].includes(item?.type) ? (
          <>
            <audio
              controls
              src={`${MEDIA_BASE_URL}${item?.message_file_key}`}
              style={{ width: "270px" }}
            />
          </>
        ) : item?.type === "application/pdf" ? (
          <a
            href={`${MEDIA_BASE_URL}${item?.message_file_key}`}
            target="_blank"
          >
            <span style={{ color: "white", textDecoration: "underline" }}>
              {item?.message}
            </span>
          </a>
        ) : (
          item?.type === "work_request" && (
            <>
              {" "}
              <span>
                {transactionLoading ? (
                  <FormattedMessage id="Translating..." />
                ) : (
                  translatedText
                )}
              </span>
              <div
                style={{
                  width: "80%",
                  height: "30px",
                  backgroundColor: "white",
                  borderRadius: "15px",
                  margin: "5px",
                  color: "grey",
                  cursor: "pointer",
                }}
                className="d-flex justify-content-center align-items-center"
                onClick={() => navigate(`/contract-details?id=${contractId}`)}
              >
                <span>
                  {" "}
                  <FormattedMessage id="tap_to_view" />
                </span>
              </div>
            </>
          )
        )}

        <span className="w-100 d-flex justify-content-end">
          {convertTime(item?.created_at)}
        </span>
      </div>
    </div>
  );
};
